





















































import { Component, Mixins } from "vue-property-decorator";
import { CommonTabMixin } from "./mixins";
import { WorkflowPhaseReference } from "../../../../domain/workflow/reference";


@Component({
  components: {
  }
})
export default class WorkflowReferenceTab extends Mixins(CommonTabMixin) {

  get phases(): WorkflowPhaseReference[] {
    return this.workflow ? this.workflow.phases : [];
  }

  setCurrentRow(rowInfo: { row: WorkflowPhaseReference, rowIndex: number}): string {
    return rowInfo.row.isCurrentPhase ? "current" : "";
  }

}
